import { useMutation, useQueryClient } from "react-query";
import axios from "../axios";
import { AddItemResponse } from "../../constants/types";

const createItem = async (formData: FormData) => {
    const response = await axios.post<AddItemResponse>("/api/item", formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
};

export default function useCreateItem() {
    const queryClient = useQueryClient();

    return useMutation((formData: FormData) => createItem(formData), {
        onSuccess: () => {
            queryClient.invalidateQueries(["item"]);
        },
    });
}
